// src/domains/shell.keys.ts —— 模板键归属（TD-823，admin-keys 用例按片 owner 推导核对）：原型键 24 + 外壳新增键
export const KEYS = [
  'adminUser', 'doLogin', 'enBtn', 'hasTabs', 'isApp', 'isLogin', 'langLabel', 'logout', 'nav', 'onAdminUser', 'openMyPwd', 'pageHint',
  'pageTitle', 'pg', 'setEn', 'setZh', 'sidebarOpen', 'sidebarStyle', 't', 'tabs', 'toast', 'toggleLang', 'toggleSidebar', 'zhBtn',
  'loginPwd', 'onLoginPwd', 'loginOtp', 'onLoginOtp', 'loginErr', 'otpStyle', 'busyLogin', 'isOnboard', 'onb', 'onOnb', 'onbSubmit', 'onbLogout',
  'busyOnb', 'copySecret', 'acctName', 'acctRole', 'acctAvatar', 'upChip', 'bell', 'noPermAny', 'isBooting',
  'idle', // 0353b 空闲自动退出提示框（2026-10-15）
  'acctTg', // 0047 G-12 块账号区「Telegram ID」个人设置（0049，06 C-33）
] as const;
